<div class="l-form">
  <label translate *ngIf="label">{{ label }}</label>
  <span translate *ngIf="require" class="c-require">必須</span>
  <div class="l-form__content">
    <input
      #text
      [type]="type"
      [value]="control.value"
      [placeholder]="placeholder"
      (input)="onChange(text.value)"
      (blur)="onTouched()"
      required
      [ngClass]="{
        'c-error': control?.invalid && (control?.dirty || control?.touched)
      }"
    />
    <div class="l-help" *ngIf="helpText">
      <p>{{ helpText }}</p>
    </div>
    <div class="l-error">
      <div *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <div translate class="error-messege" *ngIf="control.errors?.email">
          <!-- 有効なメールアドレスで入力してください。 -->
          {{ "error.email" }}
        </div>
        <div
          class="error-messege"
          *ngIf="control?.errors?.required"
          style="display: flex"
        >
          <p translate>{{ label }}</p>
          <!-- <p>+ "を入力してください。"</p> -->
          <p translate>&nbsp;{{ "error.required" }}</p>
        </div>
        <div
          translate
          class="error-messege"
          *ngIf="control?.errors?.notMatchPassword"
        >
          パスワードが一致しません。
        </div>
        <div
          translate
          class="error-messege"
          *ngIf="control?.errors?.notMatchKana"
        >
          カタカナで入力してください。
        </div>
        <div
          translate
          *ngIf="control?.errors?.maxlength"
          class="error-messege"
          style="display: flex"
        >
          <p translate>{{ label }}</p>
          <p translate>&nbsp;{{ "error.maxValue" }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
